import { render, staticRenderFns } from "./SuggestedIcon.vue?vue&type=template&id=5120048f"
import script from "./SuggestedIcon.vue?vue&type=script&lang=js"
export * from "./SuggestedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports